/* ============================================================
   HYDRUS CATALOG — sticky pills scroll-spy + smooth anchor nav
   Singleton-guarded. Document-level event delegation.
   Consumed by: hydrus-cat-pills sections.
   ============================================================ */
(function () {
  'use strict';

  if (window.__hydrusCatInit) return;
  window.__hydrusCatInit = true;

  function activate(pillsRoot, targetId) {
    if (!pillsRoot) return;
    var pills = pillsRoot.querySelectorAll('.hydrus-cat-pills__pill');
    var active = null;
    pills.forEach(function (pill) {
      var href = pill.getAttribute('href') || '';
      var match = href === '#' + targetId;
      pill.classList.toggle('is-active', match);
      if (match) active = pill;
    });
    if (active) {
      var track = pillsRoot.querySelector('.hydrus-cat-pills__track');
      if (track) {
        var pillLeft = active.offsetLeft;
        var pillCenter = pillLeft - (track.clientWidth / 2) + (active.clientWidth / 2);
        track.scrollTo({ left: pillCenter, behavior: 'smooth' });
      }
    }
  }

  function initPills(pillsRoot) {
    if (!pillsRoot || pillsRoot.__hydrusCatPillsBound) return;
    pillsRoot.__hydrusCatPillsBound = true;

    // Find all group targets referenced by pills
    var pills = pillsRoot.querySelectorAll('.hydrus-cat-pills__pill');
    var targetIds = [];
    pills.forEach(function (pill) {
      var href = pill.getAttribute('href') || '';
      if (href.indexOf('#') === 0 && href.length > 1) {
        targetIds.push(href.slice(1));
      }
    });

    // IntersectionObserver on group sections — activate pill whose group
    // is most visible. rootMargin top negative so pill activates when
    // group enters the upper third of viewport (under the sticky pill bar).
    var targets = [];
    targetIds.forEach(function (id) {
      var el = document.getElementById(id);
      if (el) targets.push(el);
    });
    if (!targets.length) return;

    var observer = new IntersectionObserver(function (entries) {
      var best = null;
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          if (!best || entry.intersectionRatio > best.intersectionRatio) {
            best = entry;
          }
        }
      });
      if (best && best.target && best.target.id) {
        activate(pillsRoot, best.target.id);
      }
    }, {
      rootMargin: '-120px 0px -55% 0px',
      threshold: [0.01, 0.25, 0.5]
    });
    targets.forEach(function (t) { observer.observe(t); });
  }

  // Click delegation — smooth scroll to anchor with scroll-margin-top
  // already handled via CSS, but we explicitly prevent default jump so
  // the pill's active state updates smoothly rather than instantly.
  document.addEventListener('click', function (e) {
    var pill = e.target.closest && e.target.closest('.hydrus-cat-pills__pill');
    if (!pill) return;
    var href = pill.getAttribute('href') || '';
    if (href.indexOf('#') !== 0 || href.length < 2) return;
    var target = document.getElementById(href.slice(1));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    var pillsRoot = pill.closest('.hydrus-cat-pills');
    activate(pillsRoot, href.slice(1));
  }, false);

  function initAll() {
    document.querySelectorAll('.hydrus-cat-pills').forEach(initPills);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-initialize after section rerender (Shopify editor + variant reactivity)
  document.addEventListener('shopify:section:load', initAll);
})();
